import {
  Flex,
  Heading,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tooltip, useMediaQuery,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { onLink, onSave, onDownload } from '../../handlers';
import { getHelpCenterLink } from './utils';

const MobileHeader = ({ props }) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const helpCenterLink = getHelpCenterLink();
  const isMobile = useMediaQuery('(max-width: 768px)', {ssr:false})
  if (isMobile[0] === true) {
    return (

      <Flex
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
      >
        <Menu>
          {({ isOpen }) => (
            <>
              <Tooltip
                label="Menu"
                hasArrow
                bg="WHITE"
                color="BLACK"
                fontWeight={600}
                borderRadius={99}
              >
                <MenuButton as="button" isActive={isOpen}>
                  <HamburgerIcon color="WHITE" fontSize="36px" />
                </MenuButton>
              </Tooltip>
              <MenuList bg="BLACK" width="100vw" border="none" borderRadius={0}>
                <Link
                  key="resumes"
                  onClick={() =>
                    onLink(formikProps, stateProps, 'resumes', false)
                  }
                >
                  <MenuItem
                    height="60px"
                    display="flex"
                    justifyContent="center"
                    _hover={{ bg: 'ORANGE', outline: 'none' }}
                    _focus={{ outline: 'none' }}
                  >
                    <Heading
                      color="black" variant="navMenu">My Resumes</Heading>
                  </MenuItem>
                </Link>
                <Link href={helpCenterLink} isExternal>
                  <MenuItem
                    color="black"
                    height="60px"
                    display="flex"
                    justifyContent="center"
                    _hover={{ bg: 'ORANGE', outline: 'none' }}
                    _focus={{ outline: 'none' }}
                  >
                    <Heading color="black" variant="navMenu">Help Center</Heading>
                  </MenuItem>
                </Link>
              </MenuList>
            </>
          )}
        </Menu>

        <Image src="/app/images/site-header-logo.png" alt="RS Works Logo" height="48px" />

        <Menu>
          {({ isOpen }) => (
            <>
              <Tooltip
                label="Actions"
                hasArrow
                bg="ORANGE"
                color="BLACK"
                fontWeight={600}
                borderRadius={99}
              >
                <MenuButton as="button" isActive={isOpen}>
                  <HamburgerIcon color="ORANGE" fontSize="36px" />
                </MenuButton>
              </Tooltip>
              <MenuList bg="BLACK" width="100vw" border="none" borderRadius={0}>

                <Link
                  onClick={e => onSave(e, formikProps, stateProps, resumeIndex)}
                >
                  <MenuItem
                    height="60px"
                    display="flex"
                    justifyContent="center"
                    color="ORANGE"
                    _hover={{ bg: 'ORANGE', color: 'BLACK' }}
                    _focus={{ outline: 'none' }}
                  >
                    <Heading variant="navActions">Save</Heading>
                  </MenuItem>
                </Link>

                <Link
                  onClick={e => onLink(false, formikProps, stateProps, 'preview')}
                >
                  <MenuItem
                    height="60px"
                    display="flex"
                    justifyContent="center"
                    color="ORANGE"
                    _hover={{ bg: 'ORANGE', color: 'BLACK' }}
                    _focus={{ outline: 'none' }}
                  >
                    <Heading variant="navActions">Preview</Heading>
                  </MenuItem>
                </Link>
              </MenuList>
            </>
          )}
        </Menu>
      </Flex>
    );
  } else {
    return null;
  }
};

export default MobileHeader;
/*
<Link
                  onClick={e =>
                    onDownload(e, formikProps, stateProps, resumeIndex)
                  }
                >
                  <MenuItem
                    height="60px"
                    display="flex"
                    justifyContent="center"
                    color="ORANGE"
                    _hover={{ bg: 'ORANGE', color: 'BLACK' }}
                    _focus={{ outline: 'none' }}
                  >
                    <Heading variant="navActions">Download</Heading>
                  </MenuItem>
                </Link>
                <Link
                  onClick={() => onCheck(formikProps, stateProps, navSections)}
                >
                  <MenuItem
                    height="60px"
                    display="flex"
                    justifyContent="center"
                    color="ORANGE"
                    _hover={{ bg: 'ORANGE', color: 'BLACK' }}
                    _focus={{ outline: 'none' }}
                  >
                    <Heading variant="navActions">Preview</Heading>
                  </MenuItem>
                </Link>
 */